import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export const DANISH_NUMBER_REGEX = '^\\d*(\\.\\d{3})*(,\\d+)*$';

export class CustomValidators {
  static danishNumberMin(min: number): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      return this.doCheck(control.value, value => value >= min, { min: 'too low' });
    };
  }

  static danishNumberMax(max: number): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      return this.doCheck(control.value, value => value <= max, { max: 'too high' });
    };
  }

  static trimRequired(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      return this.trim(control.value, { trimRequired: 'trimRequired' });
    };
  }

  static dateLength(length: number): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const errors: ValidationErrors = control.errors;
      return control.value.toString().length > length ? errors : null;
    };
  }

  private static trim(controlvalue: any, errors: ValidationErrors) {
    let value = controlvalue as string;
    if (!value) {
      value = '' + controlvalue;
    }

    value = value.toString().trim();

    if (value.length > 0) {
      return null;
    } else {
      return errors;
    }
  }

  private static doCheck(
    controlvalue: any,
    isValidFn: (value: any) => boolean,
    errors: ValidationErrors
  ): ValidationErrors | null {
    // If the control value is already a number we can do "normal" min check on the value
    if (typeof controlvalue === 'number') {
      if (isValidFn(controlvalue)) {
        return null;
      } else {
        return errors;
      }
    }

    // Else we try to parse the string as a danish number and do the check on that number
    const value = controlvalue as string;

    if (!value) {
      return null;
    }

    if (new RegExp(DANISH_NUMBER_REGEX).test(value)) {
      const internationalNumberString = value.replace(/\./g, '').replace(/,/g, '.');
      const internationalNumber = parseFloat(internationalNumberString);
      if (!isValidFn(internationalNumber)) {
        return errors;
      }
    }

    // If the value entered was not a danish string we can't check the min requirement
    return null;
  }
}
